export default __webpack_public_path__ + "assets/079cacaba8c040dc632a8338bd579009.svg";